import Index from './Index.vue';

export default {
  path: 'cidades',
  name: 'cidade',
  component: Index,
};
